import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import userService from './slices/userServiceSlice'
import missionControlService from './slices/missionControlServiceSlice'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        userService,
        missionControlService,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
